import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { ApplyFiltersContext } from "components/Filters";
import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Module } from "types/generated";

import {
  ModulesSuggestions,
  SEARCH_MODULES_SUGGESTIONS_DICTIONARY,
} from "../../FiltersLayout/constants";
import useModulesAnalytics from "../../useModulesAnalytics";

const ModulesTableLabelsCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const { applyLabelFilter, applyFilter } = useTypedContext(ApplyFiltersContext);

  const trackAnalytics = useModulesAnalytics();

  const handleApplyLabelFilter = useCallback(
    (value: string) => {
      trackAnalytics("Label clicked", { type: ModulesSuggestions.Label });
      applyLabelFilter(ModulesSuggestions.Label)(value);
    },
    [trackAnalytics, applyLabelFilter]
  );

  const handleApplyFolderFilter = useCallback(
    (value: string) => {
      trackAnalytics("Label clicked", { type: ModulesSuggestions.Folder });
      applyFilter(ModulesSuggestions.Folder, SEARCH_MODULES_SUGGESTIONS_DICTIONARY)(value);
    },
    [trackAnalytics, applyFilter]
  );

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels
        tags={module.labels}
        applyLabelFilter={handleApplyLabelFilter}
        applyFolderFilter={handleApplyFolderFilter}
      />
    </TableSimpleCell>
  );
};

export default ModulesTableLabelsCell;
